import { BUTTON_SIZE, BUTTON_TYPES, ButtonProps } from '@src/quince-components/src'
import { TrackingBrowserEventTypes } from '../helpers/tracking-event/tracking-event'
import Link from './Link'
import ContentfulButton from './contentful/ContentfulButton'

interface IButton {
  id: string
  label: string
  rounded: boolean
  size?: BUTTON_SIZE
  type?: BUTTON_TYPES
  classNames?: string[]
  link?: Link
  readonly mobileClassNames?: string[]
  readonly dynamicValueClassesMobile?: string[]
  readonly baseDynamicValueClasses?: string[]
  readonly trackingId?: string
  readonly trackingTypes?: TrackingBrowserEventTypes[]
  readonly trackConfig?: any
}

export default class Button implements IButton {
  readonly id: string
  readonly label: string
  readonly rounded: boolean
  readonly size?: BUTTON_SIZE
  readonly type?: BUTTON_TYPES
  readonly classNames?: string[]
  readonly link?: Link
  readonly mobileClassNames?: string[]
  readonly dynamicValueClassesMobile?: string[]
  readonly baseDynamicValueClasses?: string[]
  readonly trackingId?: string
  readonly trackingTypes?: TrackingBrowserEventTypes[]
  readonly trackConfig?: any

  constructor({
    id,
    label,
    rounded,
    size,
    type,
    classNames,
    link,
    mobileClassNames = [],
    dynamicValueClassesMobile = [],
    baseDynamicValueClasses = [],
    trackingId,
    trackingTypes,
    trackConfig,
  }: IButton) {
    this.id = id
    this.label = label
    this.rounded = rounded
    this.size = size
    this.type = type
    this.classNames = classNames
    this.link = link
    this.mobileClassNames = mobileClassNames
    this.dynamicValueClassesMobile = dynamicValueClassesMobile
    this.baseDynamicValueClasses = baseDynamicValueClasses
    this.trackingId = trackingId
    this.trackingTypes = trackingTypes
    this.trackConfig = trackConfig
    return {
      ...this,
    }
  }

  static makeButtonProps(button?: Button | null) {
    if (!button) return
    return {
      id: button.id,
      children: button.label,
      size: button.size,
      type: button.type,
      round: button.rounded,
      className: button.classNames?.join(' '),
      href: button.link?.navigationPath,
      mobileClassNames: button.mobileClassNames,
      baseDynamicValueClasses: button.baseDynamicValueClasses,
      dynamicValueClassesMobile: button.dynamicValueClassesMobile,
      trackingId: button.trackingId,
      trackingTypes: button.trackingTypes,
      trackConfig: button.trackConfig,
    } as ButtonProps
  }

  static fromContentful(contentfulButton: ContentfulButton) {
    return new Button({
      id: contentfulButton.id,
      label: contentfulButton.title,
      classNames: contentfulButton.classNames,
      rounded: contentfulButton.rounded,
      size: contentfulButton.size,
      type: contentfulButton.type,
      link: contentfulButton.link ? Link.fromContentful(contentfulButton.link) : undefined,
      mobileClassNames: contentfulButton.mobileClassNames || [],
      baseDynamicValueClasses: contentfulButton.baseDynamicValueClasses || [],
      dynamicValueClassesMobile: contentfulButton.dynamicValueClassesMobile || [],
      trackingId: contentfulButton.trackingId,
      trackingTypes: contentfulButton.trackingTypes,
    })
  }
}
